module.exports = __webpack_public_path__ + "6f2314ba5f6f2fb53831e548b39ab52c.pdf";